import React from 'react'

const SvgBackpackOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M9.75 11.844c.103-1.109 1.136-2.009 2.25-2.009 1.092 0 2.1.869 2.253 2.037a.75.75 0 101.488-.195C15.492 9.784 13.867 8.335 12 8.335c-1.846 0-3.565 1.448-3.744 3.37a.75.75 0 001.493.14zM8.06 16.032a1 1 0 011-1h5.88a1 1 0 011 1v1.704a1 1 0 01-1 1H9.06a1 1 0 01-1-1v-1.704z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 4.933A2.933 2.933 0 0110.933 2h2.134A2.933 2.933 0 0116 4.933v1.142a7.997 7.997 0 014 6.93v7.736c0 .695-.564 1.259-1.259 1.259H5.26A1.259 1.259 0 014 20.741v-7.737a7.997 7.997 0 014-6.93v-1.14zm6.4 0v.438a7.996 7.996 0 00-2.4-.367c-.836 0-1.642.129-2.4.367v-.438c0-.736.597-1.333 1.333-1.333h2.134c.736 0 1.333.597 1.333 1.333zM18 20v-6.996a6 6 0 00-12 0V20h12z'
    />
    <path d='M5.358 2.09L3.224 3.594a.548.548 0 00-.209.573l.906 3.832a9.55 9.55 0 012.837-2.923l-.632-2.672c-.084-.357-.478-.519-.768-.314zM17.242 5.076A9.551 9.551 0 0120.08 8l.906-3.832a.548.548 0 00-.21-.573L18.643 2.09c-.29-.205-.683-.043-.768.314l-.632 2.672z' />
  </svg>
)

export default SvgBackpackOutline
